 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-1726fc00":"488dbd3d","chunk-0d246031":"dbd8e619","chunk-50dd59bc":"1b21f194","chunk-ef3e40a2":"60712111","chunk-fb94cf76":"ed8e06d7","chunk-0d5e053c":"40853901","chunk-6eddcd26":"6c1275c1","chunk-1de0c504":"760a58f1","chunk-22bce2bb":"c164255a","chunk-26859e1c":"948175f9","chunk-26a9e3cb":"c2de00a8","chunk-2d0c113d":"382afec3","chunk-33d46f00":"edcb68d8","chunk-00f48664":"c455a122","chunk-3804297c":"7cd358c7","chunk-3fbc5436":"a76bc1d4","chunk-50fd203d":"8987e546","chunk-51bcbf5c":"831c7f57","chunk-5529299e":"d88af56f","chunk-588a8186":"72c9de11","chunk-5e550473":"f4a86a10","chunk-6161b3c2":"4e4ab177","chunk-656c0c48":"756218b4","chunk-895e17c2":"01670c5c","chunk-504c6c0e":"90730492","chunk-98085450":"df21d62c","chunk-a2ebb374":"6fe4c148","chunk-b7824540":"021d3e56","chunk-d1d9c92e":"355b2aa7","chunk-2193aca8":"b76b4d56","chunk-7e2e6c35":"9d896ea4","chunk-6fc10b30":"fb0bc110","chunk-1d230221":"2a1bd63b","chunk-5f16e7ae":"31b55776","chunk-0a146e9c":"ce40daba","chunk-39629135":"9d7edf68","chunk-e625cc10":"201f1f15","chunk-e4fe65dc":"9e36e94f","chunk-d44218ca":"e3a2f445","chunk-da3be67e":"0cb39063","chunk-743c2ddb":"a76340f5","chunk-7457c560":"de003d3e","chunk-745a3122":"a496ad2d","chunk-7467d5b8":"81acc37a","chunk-7482e5bc":"a45e4312","chunk-74af77ea":"72d835d8","chunk-74b7681c":"af3b4519","chunk-74bb0962":"1d1c34d4","chunk-76f042f8":"cf4c94f3","chunk-774c8cf7":"d2e748d9","chunk-c550e5be":"6b0e954b","chunk-11f3b708":"200ea8d4","chunk-2ad945e0":"236bf4fa","chunk-2d2223ef":"1d893e43","chunk-3eb4076b":"f228b747","chunk-a4a5f68c":"3e287743","chunk-26a93a8e":"0e828691"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1726fc00":1,"chunk-0d246031":1,"chunk-50dd59bc":1,"chunk-ef3e40a2":1,"chunk-fb94cf76":1,"chunk-0d5e053c":1,"chunk-6eddcd26":1,"chunk-1de0c504":1,"chunk-22bce2bb":1,"chunk-26859e1c":1,"chunk-26a9e3cb":1,"chunk-00f48664":1,"chunk-3804297c":1,"chunk-3fbc5436":1,"chunk-50fd203d":1,"chunk-51bcbf5c":1,"chunk-5529299e":1,"chunk-588a8186":1,"chunk-5e550473":1,"chunk-6161b3c2":1,"chunk-656c0c48":1,"chunk-504c6c0e":1,"chunk-98085450":1,"chunk-a2ebb374":1,"chunk-b7824540":1,"chunk-d1d9c92e":1,"chunk-2193aca8":1,"chunk-7e2e6c35":1,"chunk-6fc10b30":1,"chunk-1d230221":1,"chunk-0a146e9c":1,"chunk-39629135":1,"chunk-e625cc10":1,"chunk-e4fe65dc":1,"chunk-d44218ca":1,"chunk-da3be67e":1,"chunk-743c2ddb":1,"chunk-7457c560":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1,"chunk-c550e5be":1,"chunk-11f3b708":1,"chunk-2ad945e0":1,"chunk-3eb4076b":1,"chunk-a4a5f68c":1,"chunk-26a93a8e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-1726fc00":"ed7d9c28","chunk-0d246031":"da6ec068","chunk-50dd59bc":"083d4e36","chunk-ef3e40a2":"5e9635bb","chunk-fb94cf76":"843aca44","chunk-0d5e053c":"4ec1c247","chunk-6eddcd26":"a539bc9c","chunk-1de0c504":"3a4a1d1f","chunk-22bce2bb":"7390c503","chunk-26859e1c":"88b910f9","chunk-26a9e3cb":"1f232d16","chunk-2d0c113d":"31d6cfe0","chunk-33d46f00":"31d6cfe0","chunk-00f48664":"8b7a490a","chunk-3804297c":"9f69edb5","chunk-3fbc5436":"5db1ed8c","chunk-50fd203d":"e71fcd5e","chunk-51bcbf5c":"ef0da253","chunk-5529299e":"3253391f","chunk-588a8186":"c3ad9921","chunk-5e550473":"c3ad9921","chunk-6161b3c2":"39b456c1","chunk-656c0c48":"705b1b3c","chunk-895e17c2":"31d6cfe0","chunk-504c6c0e":"778ddcf8","chunk-98085450":"b27edd21","chunk-a2ebb374":"55ec8d40","chunk-b7824540":"cf5ce7ea","chunk-d1d9c92e":"ff51dd4f","chunk-2193aca8":"78c9cdb9","chunk-7e2e6c35":"b633523f","chunk-6fc10b30":"c9533348","chunk-1d230221":"9d5a0ae1","chunk-5f16e7ae":"31d6cfe0","chunk-0a146e9c":"db24c3b4","chunk-39629135":"fc21005e","chunk-e625cc10":"9203c0bc","chunk-e4fe65dc":"e71fcd5e","chunk-d44218ca":"b4d38a94","chunk-da3be67e":"5a17e23d","chunk-743c2ddb":"0dd2478f","chunk-7457c560":"d4ad834b","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c","chunk-c550e5be":"103a36ca","chunk-11f3b708":"a6a6a033","chunk-2ad945e0":"64023625","chunk-2d2223ef":"31d6cfe0","chunk-3eb4076b":"10420059","chunk-a4a5f68c":"417c6c07","chunk-26a93a8e":"dab78955"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
